var _g, _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDockerLogo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "12 12 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13626_238295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2543 25.5C13.1869 25.4999 13.1201 25.5135 13.058 25.54C12.996 25.5664 12.9399 25.6051 12.8932 25.6538C12.8464 25.7025 12.8101 25.7601 12.7862 25.8232C12.7624 25.8863 12.7515 25.9536 12.7543 26.021C12.9643 30.994 16.1733 34.5 21.2443 34.5C26.4904 34.5 32.2444 30.247 32.2444 25C34.8854 25.5 35.2444 23.5 35.2444 23.5C35.1361 23.1871 34.9607 22.9015 34.7307 22.6634C34.5006 22.4252 34.2213 22.2402 33.9123 22.1211C33.6032 22.0021 33.272 21.952 32.9416 21.9742C32.6112 21.9965 32.2896 22.0906 31.9994 22.25C32.4994 19.75 29.7494 18.5 29.7494 18.5C29.7494 18.5 28.2494 21 29.7494 23C29.7494 23 30.2494 25.5 28.2494 25.5H13.2543Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2461 29.5C18.9699 29.5 18.7461 29.2761 18.7461 29C18.7461 28.7239 18.9699 28.5 19.2461 28.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2451 29.5C19.5213 29.5 19.7451 29.2761 19.7451 29C19.7451 28.7239 19.5213 28.5 19.2451 28.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4941 21.5H14.4941V25.5H18.4941V21.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 21.5H18.4951V25.5H22.4951V21.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 21.5H22.4961V25.5H26.4961V21.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 17.5H18.4951V21.5H22.4951V17.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 13.5H18.4951V17.5H22.4951V13.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 17.5H22.4961V21.5H26.4961V17.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13626_238295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(12 12)"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "12 12 24 24",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13626_238295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2543 25.5C13.1869 25.4999 13.1201 25.5135 13.058 25.54C12.996 25.5664 12.9399 25.6051 12.8932 25.6538C12.8464 25.7025 12.8101 25.7601 12.7862 25.8232C12.7624 25.8863 12.7515 25.9536 12.7543 26.021C12.9643 30.994 16.1733 34.5 21.2443 34.5C26.4904 34.5 32.2444 30.247 32.2444 25C34.8854 25.5 35.2444 23.5 35.2444 23.5C35.1361 23.1871 34.9607 22.9015 34.7307 22.6634C34.5006 22.4252 34.2213 22.2402 33.9123 22.1211C33.6032 22.0021 33.272 21.952 32.9416 21.9742C32.6112 21.9965 32.2896 22.0906 31.9994 22.25C32.4994 19.75 29.7494 18.5 29.7494 18.5C29.7494 18.5 28.2494 21 29.7494 23C29.7494 23 30.2494 25.5 28.2494 25.5H13.2543Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2461 29.5C18.9699 29.5 18.7461 29.2761 18.7461 29C18.7461 28.7239 18.9699 28.5 19.2461 28.5",
    stroke: stroke,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2451 29.5C19.5213 29.5 19.7451 29.2761 19.7451 29C19.7451 28.7239 19.5213 28.5 19.2451 28.5",
    stroke: stroke,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4941 21.5H14.4941V25.5H18.4941V21.5Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 21.5H18.4951V25.5H22.4951V21.5Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 21.5H22.4961V25.5H26.4961V21.5Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 17.5H18.4951V21.5H22.4951V17.5Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 13.5H18.4951V17.5H22.4951V13.5Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 17.5H22.4961V21.5H26.4961V17.5Z",
    stroke: stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13626_238295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(12 12)"
  })))));
});
export default SvgIconDockerLogo;
export const raw = __webpack_public_path__ + "static/media/icon-docker-logo.6c0720a370469ef7fbbd77f35c03484b.svg";